import { getDeployArea, getDeployEnv } from "@ti/max";

function typeColor(type = "") {
  let color = "";
  switch (type) {
    case "primary":
      color = "#2d8cf0";
      break; // 蓝
    case "success":
      color = "#19be6b";
      break; // 绿
    case "warning":
      color = "#ff9900";
      break; // 黄
    case "error":
      color = "#ed4014";
      break; // 红
    case "text":
      color = "#000000";
      break; // 黑
    default:
      color = "#515a6e";
      break; // 灰
  }
  return color;
}
const capsule = function (title, info, type = "primary", ...args) {
  // Js字符串拼接 ${ }
  console.log(
    `%c ${title} %c ${info} %c`,
    "background:#35495E; padding: 1px; border-radius: 3px 0 0 3px; color: #fff;",
    `background:${typeColor(type)}; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff;`,
    "background:transparent",
    ...args,
  );
};

export const printAppInfo = () => {
  const env = getDeployEnv();
  const area = getDeployArea();
  const { APP_NAME, APP_VERSION } = process.env;
  capsule("APP_NAME", APP_NAME, "primary");
  capsule("APP_VERSION", APP_VERSION, "primary");
  capsule("DEPLOY_ENV", env, "success");
  capsule("DEPLOY_AREA", area, "success");
};
